export default __webpack_public_path__ + "static/media/inter-v2-latin-regular.f60fc6e2.woff";